import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import { toast } from 'react-toastify';

import Header from '../../components/Header';
import PromoBottomNavbar from '../../components/PromoBottomNavbar';
import RewardsAnimation from '../../animations/rewards.json';
import { getProfile } from '../../http/http';
import { removeUserToken } from '../../store/slices/userTokenSlice';

import classes from './PromoHomePage.module.css';
import { ResetTime } from '../../store/slices/timeSlice';
import { resetQuestions } from '../../store/slices/questionsSlice';
import { ResetIndex } from '../../store/slices/indexSlice';
import { resetOpponentScore } from '../../store/slices/opponentPlayerSlice';
import { resetUserScore } from '../../store/slices/userPlayerSlice';
import { useTranslation } from 'react-i18next';

const PROMO_QUIZ = {
    id: 1,
    name: 'PROMO KELASI',
    image: '/assets/images/promo.png',
};

const PromoHomePage = () => {
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    const [userProfile, setUserProfile] = useState(null);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {t}=useTranslation();

    const isSunday = new Date().getDay() === 0;

    const fetchUserProfile = async () => {
        try {
            const response = await getProfile(userToken);
            setUserProfile(response?.data?.result);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            } else {
                toast.error(t("86"));
            }
        }
    };

    useEffect(() => {
        if (userToken) {
            fetchUserProfile();
        } else {
            navigate('/');
        }
    }, [userToken]);

    const handlePlay = () => {
        navigate('/promo/finding-opponent');
    };

    return (
        <>
            <Header />

            <div className={classes.page}>
                <div className={classes.profile_section}>
                    <div className={classes.profile_sub_section}>
                        <div className={classes.profile_avatar}>
                            <img
                                src={userProfile?.image ?? '/assets/images/dummy.png'}
                                alt={userProfile?.name ?? 'Player'}
                                className={classes.avatar_image}
                            />
                        </div>
                        <div className={classes.profile_details}>
                            <p className={classes.profile_name}>
                                {userProfile?.name ?? 'Player'}
                            </p>
                            <p className={classes.profile_msisdn}>
                                {userProfile?.msisdn}
                            </p>
                        </div>
                    </div>

                    <div className={classes.user_points_container}>
                        <div className={classes.rewards_animation}>
                            <Lottie
                                animationData={RewardsAnimation}
                                loop
                                autoPlay
                                className={classes.animation}
                            />
                        </div>
                        <p className={classes.points}>
                            {userProfile?.promo_points ?? 0} pts
                        </p>
                    </div>
                </div>

                <section className={classes.prize}>
                    <p className={classes.promo_name}>PROMO KELASI</p>

                    <p className={classes.prize_amount}>30,000 XAF</p>
                    <p className={classes.prize_line}>
                        {t("132")}
                    </p>

                    <div className={classes.schedule}>
                        {/* <div className={classes.schedule_row}>
                            <span className={classes.schedule_days}>
                                {t("133")}
                                {!isSunday && (
                                    <span className={classes.today_tag}>
                                        {t("134")}
                                    </span>
                                )}
                            </span>
                            <span className={classes.schedule_winners}>
                                {t("135")}
                            </span>
                        </div> */}

                        {/* <div
                            className={`${classes.schedule_row} ${classes.schedule_double}`}
                        >
                            <span className={classes.schedule_days}>
                                {t("136")}
                                <span className={classes.double_tag}>
                                    {t("137")}
                                </span>
                                {isSunday && (
                                    <span className={classes.today_tag}>
                                        {t("138")}
                                    </span>
                                )}
                            </span>
                            <span className={classes.schedule_winners}>
                                {t("139")}
                            </span>
                        </div> */}
                    </div>

                    <p className={classes.prize_foot}>
                       {t("140")}
                    </p>
                </section>

                <section className={classes.quiz_card}>
                    <div className={classes.quiz_head}>
                        <div className={classes.quiz_thumb}>
                            <img
                                className={classes.quiz_image}
                                alt=""
                                src={PROMO_QUIZ.image}
                            />
                        </div>
                        <div className={classes.quiz_meta}>
                            <h1 className={classes.quiz_name}>
                                {PROMO_QUIZ.name}
                            </h1>
                            <p className={classes.quiz_tagline}>
                                {t("141")}
                            </p>
                        </div>
                    </div>

                    <button
                        type="button"
                        className={classes.play_btn}
                        onClick={handlePlay}
                    >
                        {t("142")}
                    </button>
                </section>
            </div>

            <PromoBottomNavbar active={0} />
        </>
    );
};

export default PromoHomePage;